import { render, staticRenderFns } from "./Schools.vue?vue&type=template&id=4360c3de&scoped=true&"
import script from "./Schools.vue?vue&type=script&lang=js&"
export * from "./Schools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4360c3de",
  null
  
)

export default component.exports